export default "__VITE_ASSET__55sakfpp__"